import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { PassthroughColumns } from '../PassthroughColumns';
import { StepHeader } from '../StepHeader';
import { getStepStatus, toggleStep } from '../../utils/rankAListHelpers';
import { ColumnInfo } from '../../types/rankAList';
import { exampleColumns } from '../../data/rankAListExamples';

interface PassthroughColumnsStepProps {
  step: number;
  expandedSteps: number[];
  setExpandedSteps: (steps: number[]) => void;
  columns: ColumnInfo[];
  passthroughColumns: string[];
  onSelect: (selectedColumns: string[]) => void;
}

export const PassthroughColumnsStep: React.FC<PassthroughColumnsStepProps> = ({
  step,
  expandedSteps,
  setExpandedSteps,
  columns,
  passthroughColumns,
  onSelect
}) => {
  const isOpen = expandedSteps.includes(3);
  
  const getTitle = () => {
    if (step > 3 && passthroughColumns.length > 0) {
      const columnNames = passthroughColumns.join(', ');
      return (
        <span>
          Passthrough Columns: <span className="text-slate-400">{columnNames}</span>
        </span>
      );
    } else if (step < 3) {
      // Show example data when displaying the example
      return (
        <span>
          Passthrough Columns: <span className="text-slate-400">company_name, location</span>
        </span>
      );
    }
    return 'Passthrough Columns';
  };
  
  return (
    <Collapsible 
      open={isOpen} 
      className="border border-slate-600 rounded-lg bg-slate-800"
    >
      <CollapsibleTrigger asChild>
        <button className="w-full" onClick={() => toggleStep(3, expandedSteps, setExpandedSteps)}>
          <StepHeader 
            stepNumber={3} 
            title={getTitle()} 
            status={getStepStatus(step, 3)}
            isOpen={isOpen}
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="px-4 pb-4">
        <PassthroughColumns 
          columns={step >= 3 ? columns : exampleColumns}
          onSelect={onSelect}
          selectedColumns={step >= 3 ? passthroughColumns : ['company_name', 'location']}
          disabled={step > 3}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}; 